module.exports = __webpack_public_path__ + "img/icon-list.099ea10e.svg";